import { render, staticRenderFns } from "./Baohu.vue?vue&type=template&id=623b4db2&scoped=true&"
import script from "./Baohu.vue?vue&type=script&lang=js&"
export * from "./Baohu.vue?vue&type=script&lang=js&"
import style0 from "./Baohu.vue?vue&type=style&index=0&id=623b4db2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623b4db2",
  null
  
)

export default component.exports